export enum PayRatePeriod {
  DAY = 'day',
  HOUR = 'hour',
}
